import {Directive, Injector, OnDestroy, Optional} from '@angular/core';

import {Viewport, ViewportEvent} from '@wm/core';
import { StylableComponent, provideAsWidgetRef, register } from '@wm/components-base';

const DEFAULT_CLS = 'app-custom-widget-container clearfix';
const WIDGET_CONFIG = {widgetType: 'wm-custom-widget-container', hostClass: DEFAULT_CLS};
declare const _: any;

@Directive({
    selector: '[wmCustomWidget]',
    providers: [
        provideAsWidgetRef(CustomWidgetDirective)
    ]
})
export class CustomWidgetDirective extends StylableComponent implements OnDestroy {
    static initializeProps = register('wm-custom-widget-container');
    constructor(inj: Injector, private viewport: Viewport) {
        super(inj, WIDGET_CONFIG);

        this.registerDestroyListener(this.viewport.subscribe(ViewportEvent.RESIZE, data => this.callback('resize', data)));
        this.registerDestroyListener(this.viewport.subscribe(ViewportEvent.ORIENTATION_CHANGE, data => this.callback('orientationchange', data)));
    }

    private callback(eventName: any, locals?: object) {
        locals = _.assign({ widget: this }, locals);
        this.invokeEventCallback(eventName, locals);
    }

    public ngOnAttach() {
        this.callback('attach');
    }

    public ngOnDetach() {
        this.callback('detach');
    }

    public override ngOnDestroy() {
        this.callback('destroy');
        super.ngOnDestroy();
    }

}
